function notInitialized() {
  throw new Error('Cookie jar is not initialized');
}

export default {
  get: notInitialized,
};



// WEBPACK FOOTER //
// ./src/scripts/application/lib/cookie_jar.js